﻿import { Inject, Component } from "@fiqas/angular-utils"
import { FIQAssist } from "../../app"
import { Application } from "../application"
import { AuthenticationService } from "../../services/authenticationService";
import { IsProcessingService } from "../../services/isProcessingService";
import { DialogService } from "../../services/dialogService";
import { LogService } from "../../services/logService";

type resetstatus = "unknown" | "ok" | "fail" | "notvalid" | "currentnotvalid";

@Component({
    module: FIQAssist,
    selector: "changePassword",
    templateUrl: "views/changePassword.html",
    require: {
        application: "^application"
    }
})
class ChangePassword {
    private application: Application;
    private activeMenuItem: string;
    private oldpassword: string;
    private newpassword: string;
    private confirmpassword: string;
    private errortextold: string = "";
    private errortextnew: string = "";
    private status: resetstatus = "unknown";
    private forceTooltip: boolean = false;
    private forceTooltip1: boolean = false;
    private forceTooltip2: boolean = false;

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject('$rootRouter') private $rootRouter: angular.Router,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject() private AuthenticationService: AuthenticationService,
        @Inject() private dialogService: DialogService,
        @Inject() private logService: LogService
    ) {

    }

    $onInit() {
        this.application.forcedCustomer = ' ';
        this.activeMenuItem = '';
    }

    $onDestroy() {
        this.application.forcedCustomer = null;
    }

    private async changePassword() {
        if (this.isProcessingService.IsProcessing)
            return;
        try {
            this.isProcessingService.StartProcessing();
            if (!this.newpassword || this.newpassword.length < 8 || this.newpassword.length > 50) {
                this.errortextnew = "NEW_PASSWORD_NOT_ALLOWED";
                this.status = "notvalid";
                this.forceTooltip1 = true;
                this.forceTooltip2 = true;
                this.$timeout(
                    () => {
                        this.forceTooltip1 = false
                        this.forceTooltip2 = false;
                    }, 2000
                );
            } else if (this.newpassword !== this.confirmpassword) {
                this.errortextnew = "NEW_PASSWORDS_NOT_THE_SAME";
                this.status = "notvalid";
                this.forceTooltip1 = true;
                this.forceTooltip2 = true;
                this.$timeout(
                    () => {
                        this.forceTooltip1 = false
                        this.forceTooltip2 = false;
                    }, 2000
                );
            } else {
                var result = await this.AuthenticationService.changePassword(this.AuthenticationService.username, this.oldpassword, this.newpassword, this.application.Settings.culture)
                this.dialogService.showMessageDialog('info', 'INFO', 'SAVE_PASSWORD_CHANGE_COMPLETED', { translate: true, onclose: () => this.$rootRouter.navigate(['/Home', {}]) });
            }
        } catch (error) {
            if (error['status'] == 400) {
                this.status = "currentnotvalid";
                this.errortextold = "CURRENT_PASSWORD_NOT_VALID";
                this.forceTooltip = true;
                this.$timeout(
                    () => {
                        this.forceTooltip = false;
                    }, 2000
                );
            } else {
                this.status = "fail";
                this.application.setSeqUrl(error);
                this.logService.error('ChangePassword', 'Error changing password', error);
                await this.dialogService.showErrorDialog('error', 'ERROR', 'CHANGE_PASSWORD_ERROR', { errorResult: error, translate: true });
            }
        }
        finally {
            this.isProcessingService.StopProcessing();
        };
    }

    private onChangeOld(value) {
        this.oldpassword = value;
        this.errortextold = "";
        if (this.status === "currentnotvalid") {
            this.status = "unknown";
        }
    }

    private onChangeNew(value) {
        this.newpassword = value;
        this.errortextnew = "";
        if (this.status === "notvalid") {
            this.status = "unknown";
        }
    }

    private onChangeNewConfirm(value) {
        this.confirmpassword = value;
        this.errortextnew = "";
        if (this.status === "notvalid") {
            this.status = "unknown";
        }
    }

    public back() {
        this.$window.history.back();
    }

}
